// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oX83b","col":"styles_col__WcZgi","actions":"styles_actions__1az4A","conflict":"styles_conflict__2BLYg"};